import React, { useEffect } from 'react';
import useCalendarSyncFlowStore from '../../../store/sync-flow/useCalendarSyncFlowStore';
import { Spinner } from '@ps-design-system/components/Spinner';
import { RadioGroup, RadioGroupItem } from '@ps-design-system/components/RadioGroup';
import useCalendarStore from '../../../store/calendar/useCalendarStore';
import { Text } from '@ps-design-system/components/Text';
import CalendarSelectionStrings from './strings';

const CalendarSelection = () => {
  const { initCalendarSelection } = useCalendarSyncFlowStore();

  const selectedSpaceId = useCalendarStore((state => state.selectedSpaceId));
  const cronofyCalendars = useCalendarSyncFlowStore((state) => state.cronofyCalendars);
  const selectedCronofyCalId = useCalendarSyncFlowStore((state) => state.selectedCronofyCalId);
  const setSelectedCronofyCalId = useCalendarSyncFlowStore((state) => state.setSelectedCronofyCalId);

  useEffect(() => {
    initCalendarSelection(selectedSpaceId);
  }, [selectedSpaceId]);

  return (
    <div>
      <Text className="CalendarSelection_desc-text text-gray-600">
        {CalendarSelectionStrings.description}
      </Text>
      {
        0 === cronofyCalendars.length ?
          <Spinner size="large" appearance="black"/> :
          <RadioGroup value={selectedCronofyCalId} onValueChange={setSelectedCronofyCalId}>
            {cronofyCalendars.map((cal) => (
              <RadioGroupItem
                typeface="body-2"
                key={cal.id}
                value={cal.id}
                id={cal.id}
                label={cal.name}
              >
                {cal.name}
              </RadioGroupItem>
            ))}
          </RadioGroup>
      }
    </div>
  );
};

export default CalendarSelection;
